import * as React from 'react';
import techSupportIcon from '../images/tech-support-icon.png';
import { T } from '@testout/labsim-ui-atomics';
import './SupportBox.less';
export default class SupportBox extends React.Component {
    render() {
        return (React.createElement("div", { className: 'support' },
            React.createElement(T.Text.P, { automationId: 'question' }, "Having trouble running CertMaster\u2122? Contact technical support:"),
            React.createElement("div", null,
                React.createElement("img", { src: techSupportIcon }),
                React.createElement("ul", { className: 'supportList' },
                    React.createElement("li", null,
                        "Email:",
                        ' ',
                        React.createElement(T.Link, { automationId: 'email', href: 'mailto:support@comptia.org' },
                            ' ',
                            "support@comptia.org")),
                    React.createElement("li", null,
                        "Call:",
                        ' ',
                        React.createElement(T.Link, { automationId: 'phone', href: 'tel:800-877-4889' }, "800-877-4889")),
                    React.createElement("li", null,
                        "Website:",
                        ' ',
                        React.createElement(T.Link, { automationId: 'website', href: 'https://help.comptia.org' // *** Is this the correct URL? ***
                            , target: '_blank' }, "CompTIA Support"))))));
    }
}
//# sourceMappingURL=SupportBox.js.map